import { Component, OnInit, Input, Output, EventEmitter, ViewChild, ElementRef} from '@angular/core';
import {FormControl} from '@angular/forms';
import {Observable} from 'rxjs/Observable';

import { PlatformService } from '../../../parameters/platforms/platform.service';
import { RequestParameters } from '../../models/request-parameters/parameter.model';
import { Platform } from '../../../parameters/platforms/platform.model';

@Component({
  selector: 'app-platform-autocomplete',
  templateUrl: './platform-autocomplete.component.html',
  styleUrls: ['./platform-autocomplete.component.scss']
})
export class PlatformAutocompleteComponent implements OnInit {
  @ViewChild('autoPlatforms') autoPlatforms: ElementRef;

  @Input() platformFormControl: FormControl;
  @Input('placeholder') placeholder: string;
  @Output() onPlatformSelected: EventEmitter<any> = new EventEmitter<any>();

  platforms: Observable<any> = new Observable<any>();
  platformsLoading: boolean = true;
  platformsParameters: RequestParameters = new RequestParameters();

  constructor(private platformService: PlatformService) {
    this.updatePlatforms();
  }

  ngOnInit() {
  }

  onPlatformSelect() {
    this.onPlatformSelected.emit(this.platformFormControl.value);
  }

  displayPlatforms (platform: Platform) {
    if (platform !== null) {
      return platform.name + ' -- ' + platform.domainName;
    }
  }

  filterPlatforms (filterInput: string = '') {
    if (this.platformsParameters.searchString !== filterInput) {
      this.platformsParameters.searchString = filterInput;
      this.updatePlatforms();
    }
  }

  updatePlatforms() {
    this.platformsLoading = true;
    this.platforms =  this.platformService.getPlatforms(this.platformsParameters)
      .map(
        (response) => {
          this.platformsLoading = false;
          return response.result;
        }
      );
  }
}



// WEBPACK FOOTER //
// C:/Users/DENISE/Documents/IT4U/web-callcenter/src/app/shared/components/platform-autocomplete/platform-autocomplete.component.ts